module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8n7n2n5r-ee7b9b84c2fd033ced7c32a2f4fbba18.svg";